import React, { useState, FormEvent, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Formulario, { FormField } from "../../../components/Formulario";
import { createTipoUsuario, createUsuario } from "../../../api/usuariosApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getEmpresas } from "../../../api/empresaApi";
import { getTipo } from "../../../api/tipoApi";
import { Empresa } from "../../../types/empresas";
import { buscaTipo } from "../../../types/tipo";

const AdicionarUsuario: React.FC = () => {
  const [nomeUsuario, setNomeUsuario] = useState<string>("");
  const [loginUsuario, setLoginUsuario] = useState<string>("");
  const [senhaUsuario, setSenhaUsuario] = useState<string>("");
  const [idEmpresa, setIdEmpresa] = useState<Empresa | null>(null);
  const [empresas, setEmpresas] = useState<Empresa[]>([]);
  const [tiposUsuario, setTiposUsuario] = useState<buscaTipo[]>([]);
  const [tiposUsuarioSelecionados, setTiposUsuarioSelecionados] = useState<
    buscaTipo[]
  >([]);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const [telefoneUsuario, setTelefoneUsuario] = useState<string>("");

  useEffect(() => {
    const fetchEmpresas = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const empresasData = await getEmpresas(token);
        setEmpresas(empresasData);
      } catch (error) {
        toast.error("Erro ao buscar empresas!");
        console.error("Erro ao buscar empresas:", error);
      }
    };

    const fetchTiposUsuario = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const tiposUsuarioData = await getTipo(token);
        setTiposUsuario(tiposUsuarioData);
      } catch (error) {
        toast.error("Erro ao buscar tipos de usuário!");
        console.error("Erro ao buscar tipos de usuário:", error);
      }
    };

    fetchEmpresas();
    fetchTiposUsuario();
  }, []);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }

      if (!idEmpresa) {
        toast.error("Selecione uma empresa!");
        setLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("nome_usuario", nomeUsuario);
      formData.append("login_usuario", loginUsuario);
      formData.append("senha_usuario", senhaUsuario);
      formData.append("id_empresa", idEmpresa.id.toString());
      formData.append("telefone_usuario", telefoneUsuario);
      const usuarioCriado = await createUsuario(token, formData);

      if (tiposUsuarioSelecionados && tiposUsuarioSelecionados.length > 0) {
        await Promise.all(
          tiposUsuarioSelecionados.map(async (tipo: buscaTipo) => {
            await createTipoUsuario(token, usuarioCriado.id, tipo.id);
          })
        );
      }

      toast.success("Usuário criado com sucesso!");
      navigate("/usuarios");
    } catch (error) {
      toast.error("Erro ao adicionar usuário!");
      console.error("Erro ao adicionar usuario:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleEmpresaChange = (event: React.SyntheticEvent, value: Empresa) => {
    setIdEmpresa(value);
  };

  const handleTipoUsuarioChange = (
    event: React.SyntheticEvent,
    value: buscaTipo[]
  ) => {
    setTiposUsuarioSelecionados(value);
  };

  const fields: FormField[] = [
    {
      label: "Nome do Usuário",
      type: "text",
      value: nomeUsuario,
      required: true,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setNomeUsuario(e.target.value),
    },
    {
      label: "Login",
      type: "text",
      value: loginUsuario,
      required: true,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setLoginUsuario(e.target.value),
    },
    {
      label: "Senha",
      type: "text",
      value: senhaUsuario,
      required: true,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSenhaUsuario(e.target.value),
    },
    {
      label: "Empresa",
      type: "autocomplete",
      value: idEmpresa,
      required: true,
      onChangeAutocomplete: handleEmpresaChange,
      options: empresas,
      getOptionLabel: (option: Empresa) => option.nome_empresa,
    },
    {
      label: "Tipos de Usuário",
      type: "autocomplete",
      value: tiposUsuarioSelecionados,
      required: false,
      onChangeAutocomplete: handleTipoUsuarioChange,
      options: tiposUsuario,
      getOptionLabel: (option: buscaTipo) => option.nome_tipo,
      multiple: true,
    },
    {
      label: "Telefone do Usuário",
      type: "text",
      value: telefoneUsuario,
      required: false,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setTelefoneUsuario(e.target.value),
    },
  ];

  return (
    <Formulario
      title="Adicionar Usuário"
      fields={fields}
      onSubmit={handleSubmit}
      onBack={handleBack}
      loading={loading}
    />
  );
};

export default AdicionarUsuario;
